import { useTranslation } from 'react-i18next'
import { Sun, Sunset, Moon, Sparkles } from 'lucide-react'
import { useCurrentUser } from '@/auth'

function isBeforeNoon() {
  const now = new Date()
  return now.getHours() < 12
}

function isAfterNoon() {
  const now = new Date()
  return now.getHours() >= 12 && now.getHours() <= 17
}

function isEvening() {
  const now = new Date()
  return now.getHours() > 17
}

function formatDate() {
  const now = new Date()
  return now.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  })
}

function TimeIcon() {
  if (isBeforeNoon()) return <Sun className="w-8 h-8 text-toast" />
  if (isAfterNoon()) return <Sunset className="w-8 h-8 text-toast" />
  if (isEvening()) return <Moon className="w-8 h-8 text-forest" />
  return <Sparkles className="w-8 h-8 text-primary" />
}

export function Greeting() {
  const { t } = useTranslation()
  const user = useCurrentUser()

  // Prefer the user's first name; fall back to the email local part, then 'there'.
  const name =
    user.name?.trim().split(/\s+/)[0] ||
    user.email?.split('@')[0] ||
    'there'

  let label = t('hello', { name })

  if (isBeforeNoon()) label = t('goodMorning', { name })
  if (isAfterNoon()) label = t('goodAfternoon', { name })
  if (isEvening()) label = t('goodEvening', { name })

  return (
    <div data-test-id="greeting" className="flex items-center gap-4">
      <div className="p-3 rounded-2xl bg-secondary">
        <TimeIcon />
      </div>
      <div>
        <h1 data-test-id="greeting-text" className="text-3xl font-bold tracking-tight">{label}</h1>
        <p className="text-base text-muted-foreground mt-0.5">{formatDate()}</p>
      </div>
    </div>
  )
}
